import { Button } from "@/shared/components/ui/button";
import { Plus } from "lucide-react";
import { v4 } from "uuid";
import { useEffect } from "react";
import { useToast } from "@/shared/hooks/use-toast";
import { parseRTKQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";
import { useRltDocumentationAddItemMutation } from "@/services/backend/rlt/work-orders/api/documentation-api";
import { useErrValidationFailedContext } from "@/shared/lib/errors/err-validation-failed-context";

export function AddItemButton({
  documentationId,
  disabled = false,
}: {
  documentationId: string;
  disabled?: boolean;
}) {
  const [add, { isLoading, error, isSuccess, reset }] =
    useRltDocumentationAddItemMutation();
  const { toast } = useToast();
  const { resetField } = useErrValidationFailedContext();

  useEffect(() => {
    if (isSuccess) {
      // The work order's readiness check reports an insufficient
      // documentation; it may be sufficient now.
      resetField("documentation");
      reset();
    }
    if (error) {
      toast({
        variant: "destructive",
        ...parseRTKQueryError(error),
      });
    }
  }, [isSuccess, error, reset, toast, resetField]);

  const onClick = () => {
    if (isLoading) {
      return;
    }
    const newID = v4();
    add({
      id: documentationId,
      itemId: newID,
    });
  };

  return (
    <Button
      className="flex items-center space-x-2"
      onClick={onClick}
      disabled={isLoading || disabled}
    >
      <Plus />
    </Button>
  );
}
